import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import UploadFileIcon from "@mui/icons-material/UploadFile";

const icons = {
  FileUploadIcon, CloudUploadIcon,
  DriveFolderUploadIcon, UploadFileIcon
};

const Dataupload = {
  id: 'dataUpload',
  title: 'Data Upload',
  type: 'group',
  children: [
    {
      id: 'ProductUpload',
      title: 'Product Upload',
      type: 'item',
      url: '/Product-upload',
      icon: icons.UploadFileIcon
    },
    {
      id: 'FloatAmountUpload',
      title: 'Float Amount Upload',
      type: 'item',
      url: '/Float-amount-upload',
      icon: icons.DriveFolderUploadIcon,
    },
    {
      id: 'BulkUpdates&Miscellaneous',
      title: 'Bulk Updates & Miscellaneous',
      type: 'item',
      url: '/Bulk-Updates&Miscellaneous',
      icon: icons.CloudUploadIcon,
    },
  ]
};

export default Dataupload;
